var map = {
	"./border-bg-sm.png": 1362,
	"./border-bg.png": 1363,
	"./btn-active.png": 1364,
	"./cny-flower-1.webp": 1365,
	"./cny-flower-2.webp": 1366,
	"./cny-mobile-bg.webp": 1367,
	"./content-deco-1.webp": 1368,
	"./content-deco-2.webp": 1369,
	"./content-deco-3.webp": 1370,
	"./content-deco-4.webp": 1371,
	"./content-deco-5.webp": 1372,
	"./deposit-icon.webp": 1373,
	"./home-icon-active.webp": 1374,
	"./home-icon.webp": 1375,
	"./live-icon-active.webp": 1376,
	"./live-icon.webp": 1377,
	"./master-bg.png": 1378,
	"./me-icon-active.webp": 1379,
	"./me-icon.webp": 1380,
	"./platform.webp": 1381,
	"./product-overview-bg.webp": 1382,
	"./promos-icon-active.webp": 1383,
	"./promos-icon.webp": 1384,
	"./sponsor-icon-active.webp": 1385,
	"./sponsor-icon.webp": 1386,
	"./title-deco-bg.webp": 1387,
	"./title-deco-left.webp": 1388,
	"./title-deco-right.webp": 1389,
	"./vip-icon-active.webp": 1390,
	"./vip-icon.webp": 1391,
	"./withdraw-icon.webp": 1392,
	"./wwr-bg.webp": 1393,
	"./wwr-img.webp": 1394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;